import { Chart as ChartJS, registerables } from 'chart.js';
import { Line } from 'react-chartjs-2';
ChartJS.register(...registerables);

function LineChart({ chartData, options }: { chartData: any; options: any }) {
  return <Line data={chartData} options={options} />;
}

export default LineChart;
